var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"grey lighten-4",staticStyle:{"background":"#F5F5F5"}},[_c('ImNavbar'),_c('v-container',{attrs:{"fluid":""}},[_c('ImStaticBalance')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }